export const VIOLIN_ASPECT_RATIO_IN_GRID = 3 / 1;
export const VIOLIN_ASPECT_RATIO_IN_LIST = 7 / 1;
export const VIOLIN_ASPECT_RATIO_IN_INTRO = 6.5 / 1;
